// Vendors
import $ from 'jquery';

if ($('.copy-link').length) {
  $('.copy-link').on('click', function (event) {
    event.preventDefault();

    const $this = $(this);
    const $link = $this.attr('href');

    navigator.clipboard.writeText($link);
  });
}
